export function setCookie(c_name,value,expire) {//设置cookie
    var date=new Date()
    date.setSeconds(date.getSeconds()+expire)
    document.cookie=c_name+ "="+escape(value)+";path=/; expires="+date.toGMTString()
}
export function delCookie(c_name){//删除cookie
    setCookie(c_name, "", -1)
}

export function delAllCookie() {//删除所有cookie
    var keys = document.cookie.match(/[^ =;]+(?==)/g)
    if (keys) {
      for (var i in keys) {
        var date=new Date()
        date.setSeconds(date.getSeconds()-1)
        document.cookie = keys[i] + "="+escape('')+";path=/; expires="+date.toGMTString()
      }
    }
}


// WEBPACK FOOTER //
// ./src/assets/cookie.js